import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthContext';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth: AuthProvider puuttuu komponenttipuusta');
  }
  return ctx;
}

export function useUser() {
  return useAuth().user;
}

export function useOrganization() {
  return useAuth().organization;
}

/**
 * Roolinäkyvyys (BUG-H0, Joanna 12.8.2026 + Petrin linjaus: piilota osiot):
 * laskutus ja tiimin hallinta näkyvät vain owner/adminille — backend on aina
 * estänyt muutokset (role-gate), tämä piilottaa myös näkymät. Peilaa
 * worker/src/middleware/role-gate.ts ADMIN_ROLES-listaa.
 */
const ADMIN_ROLES = ['owner', 'admin'];

export function useIsAdmin(): boolean {
  const user = useUser();
  return !!user && ADMIN_ROLES.includes(user.role);
}
